import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { oakParkConfig } from "./data";

export default function OakParkPage() {
  return <CityPageTemplate config={oakParkConfig} />;
}